module.exports = __webpack_public_path__ + "static/logo-cd7c049351c64e39b523b5438c909b6e.png";